import * as C from '../../constants';
import defaultState from './defaultState';

export default {

  [C.SKI_PASS_RESET_STATE](state) {
    Object.assign(state, defaultState());
  },

  // region Available ski pass products
  [C.SKI_PASS_AVAILABLE_PRODUCTS_LOAD_PENDING](state) {
    state.availablePassProducts = {
      ...state.availablePassProducts,
      itemsLoading: true,
      itemsError: undefined,
    };
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_AVAILABLE_PRODUCTS_LOAD_FAILURE](state, payload) {
    state.availablePassProducts = {
      ...state.availablePassProducts,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_PASS_AVAILABLE_PRODUCTS_LOAD_SUCCESS](state, payload) {
    state.availablePassProducts = {
      ...state.availablePassProducts,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },
  // endregion

  // region Ski pass
  [C.SKI_PASS_PRODUCTS_LOAD_PENDING](state) {
    state.pass = {
      ...state.pass,
      itemsLoading: true,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PRODUCTS_LOAD_FAILURE](state, payload) {
    state.pass = {
      ...state.pass,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_PASS_PRODUCTS_LOAD_SUCCESS](state, payload) {
    state.pass = {
      ...state.pass,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_CREATE_PENDING](state) {
    state.availablePassProducts = {
      ...state.availablePassProducts,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_CREATE_SUCCESS](state) {
    state.availablePassProducts = {
      ...state.availablePassProducts,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_CREATE_FAILURE](state, payload) {
    state.availablePassProducts = {
      ...state.availablePassProducts,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_UPDATE_PENDING](state) {
    state.pass = {
      ...state.pass,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_UPDATE_SUCCESS](state) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_UPDATE_FAILURE](state, payload) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_PRICE_UPDATE_PENDING](state) {
    state.pass = {
      ...state.pass,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PRICE_UPDATE_SUCCESS](state) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PRICE_UPDATE_FAILURE](state, payload) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_CANCELLATION_FEE_NET_UPDATE_PENDING](state) {
    state.pass = {
      ...state.pass,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_CANCELLATION_FEE_NET_UPDATE_SUCCESS](state) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_CANCELLATION_FEE_NET_UPDATE_FAILURE](state, payload) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_DELETE_PENDING](state) {
    state.pass = {
      ...state.pass,
      saveLoading: true,
      saveError: undefined,
    };
    state.availablePassProducts = {
      ...state.availablePassProducts,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_DELETE_SUCCESS](state, items) {
    state.pass = {
      ...state.pass,
      items,
      saveLoading: false,
      saveError: undefined,
    };
    state.availablePassProducts = {
      ...state.availablePassProducts,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_DELETE_FAILURE](state, payload) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: payload,
    };
    state.availablePassProducts = {
      ...state.availablePassProducts,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_STOP_PENDING](state) {
    state.pass = {
      ...state.pass,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_STOP_SUCCESS](state) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_STOP_FAILURE](state, payload) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_CANCEL_PENDING](state) {
    state.pass = {
      ...state.pass,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_CANCEL_SUCCESS](state) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_CANCEL_FAILURE](state, payload) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_CHANGE_STATUS_PENDING](state) {
    state.pass = {
      ...state.pass,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_CHANGE_STATUS_SUCCESS](state) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_CHANGE_STATUS_FAILURE](state, payload) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_SUPPLIER_REF_UPDATE_PENDING](state) {
    state.pass = {
      ...state.pass,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_SUPPLIER_REF_UPDATE_SUCCESS](state, items) {
    state.pass = {
      ...state.pass,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_SUPPLIER_REF_UPDATE_FAILURE](state, payload) {
    state.pass = {
      ...state.pass,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_SEND_REQUEST_EMAIL_PENDING](state) {
    state.pass = {
      ...state.pass,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_SEND_REQUEST_EMAIL_SUCCESS](state) {
    state.pass = {
      ...state.pass,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_SEND_REQUEST_EMAIL_FAILURE](state, payload) {
    state.pass = {
      ...state.pass,
      itemsLoading: false,
      itemsError: payload,
    };
  },
  // endregion

  // region Ski pass search available products
  [C.SKI_PASS_SEARCH_BOOKING_PARTICIPANT_SET](state, selectedBookingParticipantId) {
    state.search.selectedBookingParticipantId = selectedBookingParticipantId;
  },

  [C.SKI_PASS_SEARCH_START_DATE_SET](state, selectedStartDate) {
    state.search.selectedStartDate = selectedStartDate;
  },

  [C.SKI_PASS_SEARCH_NUMBER_OF_DAYS_SET](state, selectedNumberOfDays) {
    state.search.selectedNumberOfDays = selectedNumberOfDays;
  },

  [C.SKI_PASS_SEARCH_AREA_SET](state, selectedAreaId) {
    state.search.selectedAreaId = selectedAreaId;
  },
  // endregion

  // region Ski pass change product
  [C.SKI_PASS_CHANGE_PRODUCT_BOOKING_PARTICIPANT_SET](state, selectedBookingParticipantId) {
    state.changeProduct.selectedBookingParticipantId = selectedBookingParticipantId;
  },

  [C.SKI_PASS_CHANGE_PRODUCT_START_DATE_SET](state, selectedStartDate) {
    state.changeProduct.selectedStartDate = selectedStartDate;
  },

  [C.SKI_PASS_CHANGE_PRODUCT_NUMBER_OF_DAYS_SET](state, selectedNumberOfDays) {
    state.changeProduct.selectedNumberOfDays = selectedNumberOfDays;
  },

  [C.SKI_PASS_CHANGE_PRODUCT_PERSON_CATEGORY_SET](state, personCategoryId) {
    state.changeProduct.selectedPersonCategoryId = personCategoryId;
  },
  // endregion

  [C.BOOKING_GET_SKI_PASS_PICKUP_PLACES_PENDING](state) {
    state.pickupPlaces = {
      loading: true,
      error: false,
      items: [],
    };
  },

  [C.BOOKING_GET_SKI_PASS_PICKUP_PLACES_SUCCESS](state, payload) {
    state.pickupPlaces = {
      loading: false,
      error: false,
      items: payload,
    };
  },

  [C.BOOKING_GET_SKI_PASS_PICKUP_PLACES_FAILURE](state) {
    state.pickupPlaces = {
      loading: false,
      error: true,
      items: [],
    };
  },

  [C.BOOKING_SAVE_SKI_PASS_PICKUP_PLACE_PENDING](state) {
    state.savePickupPlace = {
      loading: true,
      error: false,
      success: false,
    };
  },

  [C.BOOKING_SAVE_SKI_PASS_PICKUP_PLACE_SUCCESS](state) {
    state.savePickupPlace = {
      loading: false,
      error: false,
      success: true,
    };
  },

  [C.BOOKING_SAVE_SKI_PASS_PICKUP_PLACE_FAILURE](state) {
    state.savePickupPlace = {
      loading: false,
      error: true,
      success: false,
    };
  },

  [C.SKI_PASS_ASSIGN_PARTICIPANT_PENDING](state) {
    state.pass = {
      ...state.pass,
      itemsLoading: true,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_ASSIGN_PARTICIPANT_SUCCESS](state, payload) {
    state.pass = {
      ...state.pass,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_ASSIGN_PARTICIPANT_FAILURE](state, payload) {
    state.pass = {
      ...state.pass,
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_PASS_PARTICIPANT_BOOK_BY_XML_PENDING](state) {
    state.pass = {
      ...state.pass,
      itemsLoading: true,
    };
  },

  [C.SKI_PASS_PARTICIPANT_BOOK_BY_XML_SUCCESS](state, payload) {
    state.pass = {
      ...state.pass,
      itemsLoading: false,
      items: payload,
    };
  },

  [C.SKI_PASS_PARTICIPANT_BOOK_BY_XML_FAILURE](state) {
    state.pass = {
      ...state.pass,
      itemsLoading: false,
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/pass/mutations.js